import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";

const ProfileImageUploader = ({ setProfileImage, existingImage }) => {
  const [previewUrl, setPreviewUrl] = useState(null);
  const fileInputRef = useRef(null);

  // Set initial preview from existing image (base64 or URL)
  useEffect(() => {
    if (existingImage) {
      setPreviewUrl(existingImage);
    } else {
      setPreviewUrl(null);
    }
  }, [existingImage]);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Validate file type
      if (!file.type.startsWith('image/')) {
        alert('Please select an image file');
        return;
      }
      // Validate file size (max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert('Image size should be less than 5MB');
        return;
      }
      setProfileImage(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const handleIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div>
      <button
        type="button"
        onClick={handleIconClick}
        aria-label="Change profile picture"
        style={{
          width: "100px",
          height: "100px",
          borderRadius: "50%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          outline: "none",
          border: "none",
          padding: 0,
          overflow: "hidden",
          backgroundColor: "transparent",
        }}
        className="focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      >
        {previewUrl ? (
          <img
            src={previewUrl}
            alt="Profile preview"
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        ) : (
          <img
            src="/images/userProfileIcon.jpg"
            alt="Default profile icon"
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
        )}
      </button>
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={handleImageChange}
        aria-label="File input for profile picture"
      />
    </div>
  );
};

ProfileImageUploader.propTypes = {
  setProfileImage: PropTypes.func.isRequired,
  existingImage: PropTypes.string
};

export default ProfileImageUploader;
